module.exports = __webpack_public_path__ + "assets/img/o3.81102f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/picture/o3.jpg
// module id = BLMK
// module chunks = 1